import React, { useState } from "react";
import { Card, Row, Col, Button } from "react-bootstrap";
import { BiSolidStar, BiLoader } from "react-icons/bi";
import { Formik } from "formik";
import TextArea from "../../components/textField/TextArea";
import { makeRequest } from "../../utils/makeRequest";
import toastNotify from "../../utils/toastNotify";
import * as urls from '../../utils/urlConst';
import { getUserData } from "../../utils/common";
import { useNavigate } from "react-router-dom";
import { exceptionLog } from "../../utils/common";

const Feedback = () => {
  const [rating, setRating] = useState<number>(0);
  const [errorMessage, setErrorMessage] = useState<string>('');
  const [isLoader, setIsLoader] = useState<boolean>(false);
  const userData = getUserData();
  const navigate = useNavigate();

  const addFeedback = async (val: any, resetForm: any) => {
    try {
      setIsLoader(true);

      const payload = {
        Ratings: rating.toString(),
        Description: val.feedbackRemarks,
      };

      const config = {};

      await makeRequest('POST', urls.addFeedback, payload, config).then((result) => {
        if (result.STATUS === '0') {
          toastNotify(result.MESSAGE, 'success');
          navigate('/dashboard')
          resetForm();
          setRating(0);
        } else {
          toastNotify(result.MESSAGE, 'error');
        };
      })
    } catch (error: any) {
      if (error.status !== 403) {
        await exceptionLog(error, "Add feedback", "N");
      }
    } finally {
      setIsLoader(false);
    }
  }

  return (
    <div>
      <Card>
        <Card.Body>
          <Formik
            enableReinitialize={true}
            initialValues={{ feedbackRemarks: '' }}
            onSubmit={(values, { resetForm }) => {
              if (rating === 0) {
                setErrorMessage('Rating is a Required field');
                return;
              };
              setErrorMessage('')
              addFeedback(values, resetForm);
            }}
          >
            {({ values, handleBlur, handleChange, handleSubmit }) => {
              return (
                <form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={5}>
                      <label htmlFor="" className="required text-xs text-slate-500">
                        Rating
                      </label>
                      <div className="star-rating-section mt-2 mt-md-0">
                        {[1, 2, 3, 4, 5].map((i) => (
                          <div
                            key={i}
                            className={`star ${rating >= i ? "active" : ""} `}
                            onClick={() => setRating(i)}
                          >
                            <BiSolidStar style={{ color: "#ccc !important", fontSize: 25 }} />
                          </div>
                        ))}
                      </div>
                      <div className="errors">
                        <p className="error-msg">{errorMessage}</p>
                      </div>
                    </Col>

                    <Col md={8} className="mt-3">
                      <TextArea
                        label="Remarks"
                        id="feedbackRemarks"
                        name="feedbackRemarks"
                        placeholder="Add Remarks"
                        disabled={isLoader}
                        value={values.feedbackRemarks}
                        onChange={handleChange}
                        onBlur={handleBlur}
                      />
                    </Col>

                    <Col md={8}>
                      <div className="d-flex justify-content-end mt-3">
                        <Button
                          type="button"
                          variant="outline-orange"
                          className="btn-sm me-2"
                          onClick={() => navigate(-1)}
                        >
                          Cancel
                        </Button>
                        <Button type="submit" variant="orange" className="btn-sm" disabled={isLoader}>
                          {!isLoader ? 'Submit' : <><BiLoader className='icon-loader text-white text-lg' /> Loading...</>}
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </form>
              )
            }}
          </Formik>
        </Card.Body>
      </Card>
    </div >
  );
};

export default Feedback;
